// Copyright (c) 2024-2026 Noushad Khalid / Codeteki. All rights reserved.
// Licensed under the Elastic License 2.0 — see LICENSE for details.

import { Smartphone } from "lucide-react";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../lib/appLinks";
import googlePlayBadge from "../assets/badges/google-play-badge.png";
import appStoreBadge from "../assets/badges/apple-app-store-badge.svg";

const ALIGN = {
  left: "justify-start",
  center: "justify-center",
  // Hero copy on most pages is centred on mobile and left-aligned from lg up
  responsive: "justify-center lg:justify-start",
};

/** Compact App Store + Google Play badge row for page heroes. The full
 * "Get the app" band with QR codes (MobileAppBadges) sits above the footer on
 * every page; this is the above-the-fold version. `dark` flips the label
 * colour for heroes on a dark background — the badges themselves are black
 * with a light outline, so they read on either. */
export default function HeroAppBadges({ dark = false, align = "responsive", className = "" }) {
  const justify = ALIGN[align] || ALIGN.responsive;
  return (
    <div className={`mt-6 ${className}`}>
      <p className={`flex items-center gap-1.5 text-xs font-semibold mb-2 ${justify} ${dark ? "text-white/70" : "text-gray-500"}`}>
        <Smartphone className="w-3.5 h-3.5" aria-hidden="true" />
        Get the Codeteki app
      </p>
      <div className={`flex flex-wrap items-center gap-2 ${justify}`}>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
          <img src={appStoreBadge} alt="Download on the App Store" className="h-9 w-auto" width="120" height="40" />
        </a>
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
          <img src={googlePlayBadge} alt="Get it on Google Play" className="h-12 w-auto -my-1.5" width="124" height="48" />
        </a>
      </div>
    </div>
  );
}
